<template>
  <div class="card modal-card is-min-width-700"
       v-if="modeCalculHonoraireClone">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content pd-40px">
        <div class="center">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('editionClient.honoraire.popUp.title') }}
              </h1>
              <p class="has-text-default">
                {{ $t('editionClient.honoraire.popUp.sousTitle') }}
              </p>
            </div>
          </div>
        </div>
        <error-msg-component :messages="messages"
                             :error="error"
                             class="mgt-20px"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"/>
        <div class="columns is-multiline mgt-20px">
          <div class="column is-6">
            <b-field :label="$t('editionClient.honoraire.popUp.modeCalcul')">
              <b-select :value="modeCalculHonoraireClone.modeCalcul"
                        @input="updateEnumModeCalcul"
                        expanded>
                <option v-for="mode in constantes.LISTE_MODE_CALCUL"
                        :value="mode.code"
                        :key="mode.code">
                  {{ $t(mode.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field v-if="modeCalculHonoraireClone.modeCalcul !== constantes.MODE_CALCUL_MANUEL"
                     :label="getLabelPourcentageOrForfait">
              <input-currency v-model="modeCalculHonoraireClone[getModeCalculToUpdate]">
              </input-currency>
            </b-field>
          </div>
          <div class="column is-12"
               v-if="modeCalculHonoraireClone.modeCalcul === constantes.MODE_CALCUL_POURCENTAGE">
            <b-field :label="$t('editionClient.honoraire.popUp.appply')">
              <div class="has-text-default columns is-multiline">
                <b-checkbox v-model="modeCalculHonoraireClone.applicableSurLocation"
                            class="column is-12">
                <span class="has-text-default">
                  {{ $t('editionClient.honoraire.popUp.loc') }}
                </span>
                </b-checkbox>
                <b-checkbox v-model="modeCalculHonoraireClone.applicableSurTlpe"
                            class="column is-12 pdt-0">
                  {{ $t('editionClient.honoraire.popUp.tlpe') }}
                </b-checkbox>
              </div>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field :label="$t('editionClient.honoraire.popUp.commentaire')">
              <b-input type="textarea" v-model="modeCalculHonoraireClone.commentaire">
              </b-input>
            </b-field>
          </div>
        </div>
        <footer class="mgt-20px mgl-0">
          <b-field class="mgl-0">
            <div class="is-pulled-left boutonAction">
              <a class="button is-cancel btn-modal-annuler"
                 @click="$parent.close()">
                {{ $t('general.button.cancel') }}
              </a>
            </div>
            <div class="is-pulled-left boutonAction mgl-0">
              <a class="button is-addOrEdit"
                 @click="updateModeCalculHonoraire()">
                {{ $t('general.button.apply') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import inputCurrency from '@/components/general/inputCurrency';
import validationEditCalculHonoraire from '@/services/bodac/client/validation/validationEditCalculHonoraire';

export default {
  data() {
    return {
      modeCalculHonoraireClone: null,
      messages: [],
      error: false,
      constantes: {
        LISTE_MODE_CALCUL: tiersConf.LISTE_MODE_CALCUL,
        MODE_CALCUL_POURCENTAGE: tiersConf.MODE_CALCUL_POURCENTAGE,
        MODE_CALCUL_FORFAIT: tiersConf.MODE_CALCUL_FORFAIT,
        MODE_CALCUL_MANUEL: tiersConf.MODE_CALCUL_MANUEL,
      },
    };
  },
  props: {
    modeCalculHonoraire: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    inputCurrency,
  },
  computed: {
    getLabelPourcentageOrForfait() {
      const modeCalculFind = tiersConf.LISTE_MODE_CALCUL.find((modeCalcul) => {
        return modeCalcul.code === this.modeCalculHonoraireClone.modeCalcul;
      });
      return modeCalculFind ? this.$i18n.t(modeCalculFind.libelle) : '';
    },
    getModeCalculToUpdate() {
      return this.modeCalculHonoraireClone.modeCalcul === tiersConf.MODE_CALCUL_FORFAIT ? 'montantForfaitHt' : 'pourcentage';
    },
  },
  methods: {
    updateEnumModeCalcul(newModeCalcul) {
      if (newModeCalcul === this.modeCalculHonoraireClone.modeCalcul) return;
      this.modeCalculHonoraireClone.applicableSurLocation = false;
      this.modeCalculHonoraireClone.applicableSurTlpe = false;
      this.modeCalculHonoraireClone.montantForfaitHt = null;
      this.modeCalculHonoraireClone.pourcentage = null;
      this.modeCalculHonoraireClone.modeCalcul = newModeCalcul;
    },
    updateModeCalculHonoraire() {
      this.error = false;
      this.messages = [];
      validationEditCalculHonoraire(this.modeCalculHonoraireClone, this.messages);
      if (this.messages.length > 0) {
        this.error = true;
        return;
      }
      this.$emit('updateModeCalculHonoraire', this.modeCalculHonoraireClone);
      this.$parent.close();
    },
  },
  mounted() {
    this.modeCalculHonoraireClone = cloneDeep(this.modeCalculHonoraire);
  },
};

</script>
